var _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 50,
    viewBox: "0 0 25 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#EA4E44",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    x1: 0,
    y1: 25,
    x2: 25,
    y2: 25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#EA4E44",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    x1: 12.5,
    y1: 12.5,
    x2: 12.5,
    y2: 37.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePlusIcon);
export default __webpack_public_path__ + "static/media/OrangePlusIcon.8c5e0b051d243c44f96c3f635b4f3e66.svg";
export { ForwardRef as ReactComponent };